import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { CheckCircle } from "lucide-react";

interface StepCompleteProps {
  onClose: () => void;
}

export function StepComplete({ onClose }: StepCompleteProps) {
  const { t } = useTranslation("wizard");

  return (
    <div className="flex flex-col items-center gap-5 py-4 text-center">
      <div className="w-14 h-14 rounded-full bg-[var(--success-subtle)] flex items-center justify-center">
        <CheckCircle size={28} className="text-[var(--success)]" />
      </div>
      <div>
        <h2 className="text-[20px] font-bold text-foreground tracking-tight">{t("steps.complete.title")}</h2>
        <p className="text-[14px] text-muted-foreground mt-1.5 max-w-[280px] mx-auto leading-relaxed">
          {t("steps.complete.description")}
        </p>
      </div>
      <div className="flex flex-col gap-2 w-full max-w-[280px]">
        <Button className="w-full" onClick={onClose}>
          {t("steps.complete.goToDashboard")}
        </Button>
        <Button variant="ghost" className="text-muted-foreground text-[12px]" onClick={onClose}>
          {t("steps.complete.finishSkipped")}
        </Button>
      </div>
    </div>
  );
}
